import request from "@/utils/request";

// Query shared ad materials.
export const getMaterial = params => {
	return request({
		url: "/material",
		method: "GET",
		params,
	});
};

// Create shared ad material after file upload.
export const createMaterial = data => {
	return request({
		url: "/material",
		method: "POST",
		data,
	});
};

// Query ad playback rules.
export const getAdPlayRule = params => {
	return request({
		url: "/adPlayRule",
		method: "GET",
		params,
	});
};

// Create, update or logically delete ad playback rules.
export const setAdPlayRule = data => {
	return request({
		url: "/adPlayRule",
		method: "POST",
		data,
	});
};

// 批量推送至设备
export const setDevicesSetting = data => {
	return request({
		url: "/devices/setting",
		method: "POST",
		data,
	});
};
